/** Ontario / federal payday cap — $14 per $100 borrowed for a 2-week term. */
export const PDL_COST_PER_100_DEFAULT = 14;

export const PDL_TERM_LABEL = '2 weeks';

export function isPdlLoanType(input: {
  productCode?: string | null;
  productType?: string | null;
}): boolean {
  const code = (input.productCode ?? '').trim().toUpperCase();
  const type = (input.productType ?? '').trim().toUpperCase();
  return code === 'PDL' || type === 'PAYDAY_LOAN' || type === 'PAYDAY';
}

export function formatPdlCostPer100Label(costPer100 = PDL_COST_PER_100_DEFAULT): string {
  return `$${costPer100} per $100 borrowed`;
}

export function formatAnnualizedApr(value?: number | null): string | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null;
  if (Math.abs(value) <= 1) {
    return `${Math.round(value * 100)}%`;
  }
  // Product metadata stores payday APR as 3.65 (= 365%); journey metadata sends 365.
  if (value > 1 && value < 10) {
    return `${Math.round(value * 100)}%`;
  }
  return `${Math.round(value)}%`;
}

export type CapacityRateKvRow = {
  label: string;
  value: string | null;
  always: true;
};

/** Canadian payday disclosure rows for admin Decision Engine capacity panel. */
export function buildPdlCapacityRateKvRows(interestRate?: number | null): CapacityRateKvRow[] {
  return [
    {
      label: 'Cost (2-week)',
      value: formatPdlCostPer100Label(),
      always: true,
    },
    {
      label: 'APR (annualized)',
      value: formatAnnualizedApr(interestRate) ?? '365%',
      always: true,
    },
    {
      label: 'Term',
      value: PDL_TERM_LABEL,
      always: true,
    },
  ];
}
